import { getControlName } from "@theprelude/core";
import { ExternalLinkIcon } from "@theprelude/ds";
import type { SupportedMicrosoftControl } from "@/lib/azure";
import { StatusIcon } from "../status-icon";

interface MicrosoftConnectionStatusProps {
  appId: string;
  controls: Array<{
    controlCode: SupportedMicrosoftControl;
    instanceName: string;
  }>;
  requiredAdminConsent: boolean;
  requiredGlobalReaderRoleAssignment: boolean;
}

export const MicrosoftConnectionStatus = ({
  appId,
  controls,
  requiredAdminConsent,
  requiredGlobalReaderRoleAssignment,
}: MicrosoftConnectionStatusProps) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-secondary-foreground">
        Successfully connected Microsoft integrations
      </p>

      <div className="flex flex-col gap-3">
        <h3 className="text-primary-foreground font-medium">
          Connected Integrations
        </h3>
        <div className="flex flex-col gap-2">
          {controls.map((control) => (
            <div
              key={control.instanceName || control.controlCode}
              className="flex items-center gap-2"
            >
              <StatusIcon variant="success" />
              <span className="text-sm text-primary-foreground">
                {getControlName(control.controlCode)}
              </span>
            </div>
          ))}
        </div>
      </div>

      {(requiredAdminConsent || requiredGlobalReaderRoleAssignment) && (
        <div className="flex flex-col gap-3">
          <h3 className="text-primary-foreground font-medium">
            Required Actions
          </h3>
          <div className="flex flex-col gap-2">
            {requiredAdminConsent && (
              <div className="flex items-center gap-2">
                <StatusIcon variant="pending" />

                <a
                  href={`https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/CallAnAPI/appId/${appId}/isMSAApp~/false`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <span className="text-sm text-primary-foreground underline">
                    Grant admin consent in Azure portal
                  </span>
                  <ExternalLinkIcon className="size-4" />
                </a>
              </div>
            )}
            {requiredGlobalReaderRoleAssignment && (
              <div className="flex items-center gap-2">
                <StatusIcon variant="pending" />
                <span className="text-sm text-primary-foreground">
                  Add Global Reader role to app registration
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
